$(function () {

	// vypnutí cache snippetů
	if (historyExt = $.nette.ext('history')) {
		historyExt.cache = false;
	}

});
